(function(){
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  var progress = document.createElement('div');
  progress.id = 'da-progress';
  document.body.appendChild(progress);

  var heroEl = document.querySelector('.hero');

  function clamp(v,min,max){ return Math.max(min, Math.min(max, v)); }

  function updateScroll(){
    var vh = window.innerHeight;
    var scrollY = window.scrollY || document.documentElement.scrollTop;
    var docHeight = document.documentElement.scrollHeight - vh;
    var pct = docHeight > 0 ? (scrollY / docHeight) * 100 : 0;
    progress.style.width = pct + '%';
    var atBottom = (scrollY + vh) >= (document.documentElement.scrollHeight - 4);

    if (!reduceMotion){
      var scrollEls = document.querySelectorAll('main .shopify-section, main .card');
      scrollEls.forEach(function(el){
        var r = el.getBoundingClientRect();
        var start = vh * 0.95;
        var end = vh * 0.4;
        var raw = (start - r.top) / (start - end);
        var p = clamp(raw, 0, 1);
        if (atBottom) p = 1;
        el.style.setProperty('--p', p.toFixed(3));
      });

      if (heroEl){
        var hr = heroEl.getBoundingClientRect();
        var travel = clamp((0 - hr.top), 0, vh * 1.4);
        var s = 1 + (travel / (vh * 1.4)) * 0.55;
        var y = travel * 0.28;
        var o = 1 - clamp(travel / (vh * 1.4), 0, 1) * 0.6;
        heroEl.style.setProperty('--hero-y', y.toFixed(1) + 'px');
        heroEl.style.setProperty('--hero-s', s.toFixed(3));
        heroEl.style.setProperty('--hero-o', o.toFixed(3));
      }

      var bgShift = scrollY * -0.08;
      document.body.style.setProperty('--da-bg-shift', bgShift.toFixed(1) + 'px');
      document.querySelectorAll('.corner-ornament').forEach(function(c, i){
        var dir = i % 2 === 0 ? 1 : -1;
        c.style.setProperty('--da-corner-y', (scrollY * 0.1 * dir).toFixed(1) + 'px');
        c.style.setProperty('--da-corner-r', (scrollY * 0.03 * dir).toFixed(2) + 'deg');
      });
    } else {
      document.querySelectorAll('main .shopify-section, main .card').forEach(function(el){ el.style.setProperty('--p', 1); });
    }
  }

  var ticking = false;
  function onScroll(){
    if (!ticking){
      window.requestAnimationFrame(function(){ updateScroll(); ticking = false; });
      ticking = true;
    }
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', onScroll);
  updateScroll();

  var headingObserver = null;
  if (!reduceMotion && 'IntersectionObserver' in window){
    headingObserver = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting){
          entry.target.classList.add('da-heading-in');
          headingObserver.unobserve(entry.target);
        }
      });
    }, {threshold:0.4});
  }

  function splitHeading(h){
    if (h.dataset.daSplit) return;
    h.dataset.daSplit = '1';
    var words = h.textContent.trim().split(/\s+/);
    h.textContent = '';
    words.forEach(function(w, i){
      var wrap = document.createElement('span');
      wrap.className = 'da-word-wrap';
      var word = document.createElement('span');
      word.className = 'da-word';
      word.style.setProperty('--da-wd', (i * 0.05) + 's');
      word.textContent = w;
      wrap.appendChild(word);
      h.appendChild(wrap);
      h.appendChild(document.createTextNode(' '));
    });
  }

  function processNewHeadings(){
    document.querySelectorAll('main .shopify-section h1, main .shopify-section h2').forEach(function(h){
      if (reduceMotion){ h.classList.add('da-heading-in'); return; }
      if (!h.dataset.daSplit) splitHeading(h);
      if (!h.dataset.daObserved){
        h.dataset.daObserved = '1';
        if (headingObserver) headingObserver.observe(h); else h.classList.add('da-heading-in');
      }
    });
  }
  processNewHeadings();

  function bindCardInteractions(root){
    if (!reduceMotion && canHover){
      (root || document).querySelectorAll('main .card:not([data-da-bound])').forEach(function(card){
        card.setAttribute('data-da-bound', '1');
        card.addEventListener('mousemove', function(e){
          var r = card.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width - 0.5;
          var py = (e.clientY - r.top) / r.height - 0.5;
          card.style.setProperty('--ry', (px * 18).toFixed(2) + 'deg');
          card.style.setProperty('--rx', (py * -18).toFixed(2) + 'deg');
        });
        card.addEventListener('mouseleave', function(){
          card.style.setProperty('--ry', '0deg');
          card.style.setProperty('--rx', '0deg');
        });
      });
      (root || document).querySelectorAll('.button:not([data-da-bound]), a.button:not([data-da-bound]), .product-form__submit:not([data-da-bound]), .quick-add__button:not([data-da-bound])').forEach(function(btn){
        btn.setAttribute('data-da-bound', '1');
        btn.addEventListener('mousemove', function(e){
          var r = btn.getBoundingClientRect();
          var mx = (e.clientX - r.left - r.width / 2) * 0.4;
          var my = (e.clientY - r.top - r.height / 2) * 0.4;
          btn.style.setProperty('--mx', mx.toFixed(1) + 'px');
          btn.style.setProperty('--my', my.toFixed(1) + 'px');
        });
        btn.addEventListener('mouseleave', function(){
          btn.style.setProperty('--mx', '0px');
          btn.style.setProperty('--my', '0px');
        });
      });
    }
  }
  bindCardInteractions(document);

  var mainNode = document.querySelector('main');
  if (mainNode && 'MutationObserver' in window){
    var pending = false;
    var mo = new MutationObserver(function(){
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function(){
        processNewHeadings();
        bindCardInteractions(mainNode);
        updateScroll();
        pending = false;
      });
    });
    mo.observe(mainNode, {childList: true, subtree: true});
  }

  var mainEl = document.querySelector('main[data-template]');
  var submitBtn = document.querySelector('.product-form__submit');
  if (submitBtn && mainEl && mainEl.dataset.template === 'product'){
    var bar = document.createElement('div');
    bar.id = 'da-sticky-cart';
    var titleSpan = document.createElement('span');
    titleSpan.textContent = (document.title || '').split('\u2013')[0].trim();
    bar.appendChild(titleSpan);
    var btnClone = document.createElement('button');
    btnClone.type = 'button';
    btnClone.className = 'button';
    btnClone.textContent = submitBtn.textContent.trim();
    btnClone.addEventListener('click', function(){ submitBtn.click(); });
    bar.appendChild(btnClone);
    document.body.appendChild(bar);

    var barObserver = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting){
          bar.classList.remove('da-visible');
        } else if (entry.boundingClientRect.top < 0){
          bar.classList.add('da-visible');
        } else {
          bar.classList.remove('da-visible');
        }
      });
    }, {threshold:0});
    barObserver.observe(submitBtn);
  }

  /* Honest low-stock badge: reads REAL inventory from Shopify's product JSON, never a fabricated number */
  if (submitBtn && mainEl && mainEl.dataset.template === 'product'){
    fetch(window.location.pathname + '.js')
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(data){
        if (!data || !data.variants || !data.variants.length) return;
        var variant = data.variants.find(function(v){ return v.available; }) || data.variants[0];
        var qty = variant.inventory_quantity;
        var tracked = variant.inventory_management;
        if (tracked && typeof qty === 'number' && qty > 0 && qty <= 1){
          var badge = document.createElement('p');
          badge.id = 'da-stock-badge';
          badge.textContent = 'Derni\u00e8re pi\u00e8ce disponible';
          var form = submitBtn.closest('form') || submitBtn.parentElement;
          if (form && form.parentElement){
            form.parentElement.insertBefore(badge, form);
          }
        }
      })
      .catch(function(){});
  }
})();
